//@FIXME no logo for unison pill
//@FIXME read more link
//@FIXME start consult link
//@FIXME related article logic

import Layout from "components/includes/Layout";
import { useContext, useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import { logout } from "src/redux/action/auth";
import { I18nContext } from "components/I18N";
import ProList from "components/home/ProList";
import BarChart from "components/treatment/BarChart";
import CollapseMenu from "components/commons/CollapseMenu";
import Link from "next/link";
import Banner from "components/commons/Banner";
import { MOCK_BLOG, MOCK_REVIEW, MOCK_REVIEW_ED } from "configs/mockData";
import BlogSection from "components/blog/BlogSection";
import ReviewSection from "components/treatment/ReviewSection";
import ProductBox from "components/treatment/ProductBox";
import { ReviewBox } from "components/home/Testimonial";
import _ from "lodash";
import DraggableMarquee from "components/commons/DraggableMarquee";
import MarqueeItem from "components/treatment/MarqueeItem";
import LeftArrow from "components/commons/LeftArrow";
import RightArrow from "components/commons/RightArrow";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import get from "lodash/get";
import map from "lodash/map";
import icons from "components/product/icons.json";

import { API, graphqlOperation } from "aws-amplify";
import { productsByCategoryID, searchBlogs } from "src/graphql/queries";

const Page = ({ auth }) => {
  const router = useRouter();
  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);

  const marqueeCtrl = useRef({});
  const [list, setList] = useState([]);
  const [blogs, setBlogs] = useState([]);

  const getProducts = async () => {
    const catID = process.env.NEXT_PUBLIC_ENV_CAT_ED;

    const productResult = await API.graphql({
      query: productsByCategoryID,
      variables: { categoryID: catID },
      authMode: auth.user ? "AMAZON_COGNITO_USER_POOLS" : "API_KEY",
    });
    if (get(productResult, "errors", false)) {
      return false;
    }
    const productList = get(
      productResult,
      "data.productsByCategoryID.items",
      []
    );
    setList([...productList]);
    const blogResult = await API.graphql({
      query: searchBlogs,
      variables: {
        limit: 3,
        filter: { categoryIDs: { eq: catID }, status: { eq: "PUBLISHED" } },
      },
      authMode: auth.user ? "AMAZON_COGNITO_USER_POOLS" : "API_KEY",
    });
    setBlogs(get(blogResult, "data.searchBlogs.items", []));
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <Layout header headerFullwidth>
      <div className="bg-[#EAE9E5]">
        <div className="bg-[url(/images/treatment/ED-PRODUCT-1.png)] bg-[length:150%] bg-[initial] md:bg-cover md:bg-center container-wrapper bg-no-repeat ">
          <div className="relative w-full min-h-[835px] md:min-h-[60vh] lg:min-h-[calc(100vh)] ">
            <div className="absolute w-full md:w-[60%] lg:w-[40%] rounded-t-[16px] rounded-b-0 md:rounded-b-[16px] bg-white px-[24px] md:px-[48px] py-[24px] md:py-[44px] shadow-[0px_2px_16px_rgba(0,0,0,0.08)] bottom-0 md:bottom-[unset] top-[unset] md:top-[50%] translate-y-0 md:translate-y-[-50%] right-0">
              <h1 className="ed-title font-left">
                {I18n.get("treatmentEDPageTitle")}
                <br/>
                {I18n.get("treatmentEDPageSubtitle") !==
                 "treatmentEDPageSubtitle" && ( 
                 <span className="ed-subtitle font-extrabold font-[CentraNo2]">
                   {I18n.get("treatmentEDPageSubtitle")}
                 </span>
               )}
              </h1>

              <p className="text-[#2A2A2A] mt-[24px] ed-normal-txt">
                {I18n.get("treatmentEDPageDesc")}
              </p>

              <hr className="my-[24px]" />
              <ul className="flex gap-4 list-none">
                <li className="flex-1 ed-normal-txt">
                  <img src="/icons/check.svg" alt="check" />
                  <b>{I18n.get("treatmentEDPageAssured")}</b>
                </li>
                <li className="flex-1 ed-normal-txt">
                  <img src="/icons/safe.svg" alt="safe" />
                  <b>{I18n.get("treatmentEDPagePercent78Work")}</b>
                </li>
              </ul>

              <hr className="mt-[24px] mb-[32px]" />
              <div className="flex flex-col items-center">
                <p className="ed-start-price font-bold">
                  {I18n.get("treatmentEDPageStartWith180")}
                </p>
                <p
                  className="font-bold"
                  dangerouslySetInnerHTML={{
                    __html: I18n.get("treatmentEDPagePercent35Save"),
                  }}
                />
                <Link passHref href="/treatment?cat=ed">
                  <button className="big dark mobile-full">
                    <p>{I18n.get("startConsult")}</p>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProList />

      <div className="flex flex-col gap-[64px] md:gap-[120px] my-[56px] md:my-[120px]">
        {/** @desc หย่อนวันนี้ เสื่อมวันหน้า */}
        <div>
          <div className="container-wrapper xl:flex lg:flex md:flex  items-center justify-between  ">
            <p
              className="heading5 font-extrabold max-w-[410px]"
              dangerouslySetInnerHTML={{
                __html: I18n.get("treatmentEDPageTopic1"),
              }}
            />
            <div className="flex justify-center gap-6 xl:mt-[0px] lg:mt-[0px] md:mt-[0px] mt-[50px]">
              <LeftArrow grey onClick={() => marqueeCtrl.current.moveLeft()} />
              <RightArrow onClick={() => marqueeCtrl.current.moveRight()} />
            </div>
          </div>
          <div className="mt-12">
            <DraggableMarquee
              speed={25}
              itemsPerPage={{
                xs: 2,
                sm: 2,
                md: 4,
                lg: 5,
              }}
              controller={marqueeCtrl}
            >
              {map(list, (p) => (
                <MarqueeItem
                  key={p.id}
                  logo={"/images/treatment/pfizer.png"}
                  image={`/images/ed/${get(p, "name", "")}.webp`}
                  icon={`/images/product/${icons[p.name]}.png`}
                  name={p.manufacturer}
                />
              ))}
            </DraggableMarquee>
          </div>
        </div>

        {/** @desc อาการหย่อนสมรรถภาพทางเพศ */}

        <div className="container-wrapper my-[10px] lg:my-[60px] flex flex-col space-y-[80px] lg:space-y-[160px]">
          <div className="w-full row-mobile-col-md">
            <div className="flex-1">
              <img
                src="/images/treatment/ed_1_1.png"
                className="w-full lg:w-auto h-full object-cover rounded-[16px]"
              />
            </div>
            <div className="flex-1 px-[24px] lg:px-[64px] py-[32px] lg:py-0 flex flex-col justify-center">
              <img src="/icons/rock.svg" alt="hi bro" className="w-[42px]" />
              <h2 className="heading6 font-black mt-[16px] mb-[48px]">
                {I18n.get("treatmentEDPageTopic2")}
              </h2>
              <CollapseMenu title={I18n.get("treatmentEDPageWhatED")} showItems={true}>
                {I18n.get("treatmentEDPageWhatEDDetail")}
              </CollapseMenu>
              <CollapseMenu title={I18n.get("treatmentEDPageCauseED")}>
                <p>
                  {I18n.get("treatmentEDPageCauseEDDetail")}
                  {langCode === "th" && (
                    <>
                      <ul className="ml-10 list-disc my-[20px]">
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint1")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint2")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint3")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint4")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint5")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageCauseEDDetailPoint6")}
                        </li>
                      </ul>
                      {I18n.get("treatmentEDPageCauseEDDetailPoint7")}
                    </>
                  )}
                </p>
              </CollapseMenu>
              {langCode === "th" && (
                <CollapseMenu title={I18n.get("treatmentEDPageSymptoms")}>
                  <p>
                    {I18n.get("treatmentEDPageSymptomsDetail")}
                    {langCode === "th" && (
                      <ul className="ml-10 list-disc mt-[20px]">
                        <li>
                          {I18n.get("treatmentEDPageSymptomsDetailPoint1")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageSymptomsDetailPoint2")}
                        </li>
                        <li>
                          {I18n.get("treatmentEDPageSymptomsDetailPoint3")}
                        </li>
                      </ul>
                    )}
                  </p>
                </CollapseMenu>
              )}
              <CollapseMenu title={I18n.get("treatmentEDPageCanEDCure")}>
                {I18n.get("treatmentEDPageCanEDCureDetail")}
              </CollapseMenu>
              <div className="cursor-pointer flex-auto flex items-center space-x-[4px] justify-self-end mt-[38px]">
                <Link href="/erectile-dysfunction-101">
                  <p className="title font-semibold">{I18n.get("readMore")}</p>
                </Link>
                <img
                  src="/images/include/right-black.png"
                  className="h-[12px] w-auto"
                />
              </div>
            </div>
          </div>
        </div>

        {/** @desc ตัวเลือกในการรักษาของ HIBRO */}

        <div className="bg-[#F7F5F1]">
          <div className="pt-[48px] md:pt-[120px] container-wrapper mb-[40px]">
            <h2 className="title font-bold">
              {I18n.get("treatmentEDPageCanEDTreatmentOptionTitle")}
            </h2>
            <h2 className="heading5 font-bold my-[16px]">
              {I18n.get("treatmentEDPageCanEDTreatmentOptionSubtitle")}
            </h2>
            <p className="text-[#2A2A2A] w-full md:w-2/3">
              {I18n.get("treatmentEDPageCanEDTreatmentOptionDesc")}
            </p>
          </div>
          <div className="relative">
            {/* <div className="w-1/3 absolute h-full bg-black rounded-tr-[40px] left-0 top-0 z-0" /> */}
            <div className="row-mobile-col-md gap-6">
              <div className="w-[calc(100vw-10px)] md:w-[30%] xl:w-[40%] bg-cover bg-center bg-[url(/images/treatment/ed_1_2.png)] rounded-tr-[24px] rounded-br-[24px] md:rounded-tr-[40px] md:rounded-br-0">
                <div className="container-wrapper left-only h-full">
                  <div className="left-0 h-full center text-white pt-[64px] pb-[22px] items-start flex flex-col justify-between z-10 min-h-[50vh]">
                    <div>
                      <p
                        className="heading6 font-extrabold"
                        dangerouslySetInnerHTML={{
                          __html: I18n.get("treatmentEDPageTitle"),
                        }}
                      />
                      {I18n.get("treatmentEDPageSubtitle") !==
                        "treatmentEDPageSubtitle" && (
                        <p className="heading6 font-extrabold font-[CentraNo2]">
                          {I18n.get("treatmentEDPageSubtitle")}
                        </p>
                      )}
                    </div>
                    <p className="small">{I18n.get("phoneConsultIfnotSure")}</p>
                  </div>
                </div>
              </div>

              <div className="flex-1 flex flex-col z-10 items-start pb-[54px] gap-[36px] md:gap-[24px]  container-wrapper right-only ">
                <div className="overflow-scroll w-screen md:w-full">
                  <div className="flex gap-6 px-[10px] md:px-0 h-full">
                    <ProductBox id={"1"} />
                    <ProductBox id={"2"} />
                  </div>
                </div>
                {langCode === "th" && (
                  <p className="font-bold pl-[10px] md:pl-0 mt-[38px]">
                    {I18n.get("treatmentEDPageStartWith180Consult")}
                  </p>
                )}
                <p className="heading6 font-bold pl-[10px] md:pl-0">
                  {I18n.get("treatmentEDPagePriceStartWith180")}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/** @desc ผลลัพท์ในการรักษา */}

        <div className="row-mobile-col-reverse-md container-wrapper gap-24">
          <div className="flex-1 md:px-0 px-[32px]">
            <img src="/icons/rock.svg" alt="hibro" />
            <h2 className="heading6 font-bold mt-[16px] mb-[48px]">
              {I18n.get("treatmentEDPageTreatmentResult")}
            </h2>
            <p
              dangerouslySetInnerHTML={{
                __html: I18n.get("treatmentEDPageTreatmentResultDesc"),
              }}
            />
            <p className="mr-[5px] font-bold">
              {I18n.get("treatmentEDPageTreatmentResultSrcTag")}
              {"  "}
              <Link href="https://pubmed.ncbi.nlm.nih.gov/12757058">
                <a className="link small">
                  {I18n.get("treatmentEDPageTreatmentResultSrc")}
                </a>
              </Link>
            </p>
            <div className="mt-[48px]">
              <Link href="/treatment?cat=ed">
                <button className="big dark">
                  <p className="title text-white">{I18n.get("startConsult")}</p>
                </button>
              </Link>
            </div>
          </div>
          <div className="flex-1 text-center md:px-0 px-[32px]">
            <p className="title font-bold mb-6">
              {I18n.get("treatmentEDPageSuccessSexAttmp")}
            </p>
            <BarChart
              key={new Date().getTime()}
              chart1Configs={{
                color: "#2D3345",
                percent: 70,
                text: "2x",
                icon: (
                  <>
                    <img
                      src="/images/treatment/medicine-icon-1.png"
                      alt="medicine"
                    />
                    <p>{I18n.get("sildenafil")}</p>
                  </>
                ),
              }}
              chart2Configs={{
                color: "#F7F5F1",
                percent: 35,
                text: null,
                icon: (
                  <>
                    <img
                      src="/images/treatment/medicine-icon-2.png"
                      alt="medicine"
                    />
                    <p>{I18n.get("placebo")}</p>
                  </>
                ),
              }}
            />
          </div>
        </div>

        <ReviewSection
          data={MOCK_REVIEW_ED[langCode]}
          itemBuilder={({ item, isActive }) => {
            return <ReviewBox item={item} isActive={isActive} />;
          }}
        />

        <div className="container-wrapper">
          <div className="container-wrapper">
            <h2 
              className="heading6 font-bold mb-8 font-[CentraNo2] text-left md:text-center"
              dangerouslySetInnerHTML={{ __html: I18n.get("treatmentEDPageFrequentlyAskedQuestions") }}
            />

            {[
              { topic: "treatmentEDPageFAQ1", desc: "treatmentEDPageFAQ1Desc" },
              { topic: "treatmentEDPageFAQ2", desc: "treatmentEDPageFAQ2Desc" },
              { topic: "treatmentEDPageFAQ3", desc: "treatmentEDPageFAQ3Desc" },
              { topic: "treatmentEDPageFAQ4", desc: "treatmentEDPageFAQ4Desc" },
              { topic: "treatmentEDPageFAQ5", desc: "treatmentEDPageFAQ5Desc" },
              { topic: "treatmentEDPageFAQ6", desc: "treatmentEDPageFAQ6Desc" },
            ].map((item, i) => (
              <CollapseMenu title={I18n.get(item.topic)} key={item.topic} showItems={i == 0 ? true : false}>
                <p dangerouslySetInnerHTML={{ __html: I18n.get(item.desc) }} />
              </CollapseMenu>
            ))}

            <p className="items-end mt-[38px]">
              <span className="small mr-[5px]">
                {I18n.get("stillHaveQuestion")}
              </span>
              <Link href="/help-center">
                <a className="link  small">
                  {I18n.get("stillHaveQuestionVisit")}{" "}
                  <ArrowForwardIcon
                    sx={{ fontSize: "18px", color: "F29200" }}
                  />
                </a>
              </Link>
            </p>
          </div>
        </div>

        {/** @desc แก้ปัญหากังวลใจ ได้ง่ายๆ */}

        <Banner backgroundImage={"/images/ED-CTA.gif"} footer>
          <h2
            className="font-bold mb-4 heading3"
            dangerouslySetInnerHTML={{ __html: I18n.get("homePageActionED") }}
          />
          <Link passHref href="/treatment?cat=ed">
            <button className="big light">
              <p className="title text-[#060606]">{I18n.get("startConsult")}</p>
            </button>
          </Link>
        </Banner>

        {/** @desc Related Article */}
        <div className="container-wrapper">
          <h2 className="heading6 font-bold mb-6 font-[CentraNo2]">
            {I18n.get("relatedArticle")}
          </h2>
          <BlogSection items={blogs} />
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Page);
